import { LinksApi } from 'api'

export const getHomeConfiguration = () => {
  return LinksApi.get('/home/setup')
}
